export type SliderVariant = 'default' | 'stepped'

export type SliderTrackProps = {
  variant?: SliderVariant
  minimumValue: number
  maximumValue: number
  value: number
  step: number
  steps?: number
  disabled?: boolean
  onValueChange: (value: number) => boolean | void
  colorTrackFront: string
  colorTrackBack: string
}
